import React, { useCallback } from 'react'
import MapLibreMap, { addGeoJsonLayer, fitBoundsToGeoJson } from './MapLibreMap'

const LOTE_COLOR = '#81ADD2'

export default function LoteMapLibre({ loteId, className = '' }) {
  const handleMapReady = useCallback(async (map) => {
    try {
      const lote = await fetch(`/lotes/${loteId}.json`).then(r => r.json())

      if (lote) {
        addGeoJsonLayer(map, 'lote', lote, {
          type: 'both',
          color: LOTE_COLOR,
          opacity: 0.5,
          lineWidth: 2
        })

        // Fit bounds to lote
        fitBoundsToGeoJson(map, lote)
      }

    } catch (error) {
      console.error('Error loading lote map data:', error)
    }
  }, [loteId])

  return (
    <MapLibreMap
      onMapReady={handleMapReady}
      className={className}
      zoom={17}
    />
  )
}
